define([
    "language/resource",
    "authui/iamUtils",
    "base/utils/utility",
], function (i18n, iamUtils, util) {
    "use strict";
    function privacyUpdateCtrl($scope,$state){
       $scope.model = {
            privacyPolicyUpdate: i18n("privacyPolicyUpdate"),
            privacyTipPre: i18n("privacyTipPre"),
            privacyTipSuf: i18n("privacyTipSuf"),
            secretprotect: i18n("secretprotect"),
            btnTxtOK: i18n("agreementBtnTxt"),
            btnTxtCancel: i18n("btnTxtCancel"),
            checked: true,
            disable: false,
            privacyAgreement: "https://www.huaweicloud.com/declaration/sa_prp_current.html",
            chkChange: function () {
                if (this.checked) {
                    $scope.model.disable = false;
                }
                else {
                    $scope.model.disable = true;
                }
            },
        }
        $(document).keydown(function (event) {
            if(event.keyCode === 13){
                if ( $scope.model.disable === false ) {
                    $scope.onSubmitClick();
                }
            }
        });
        $scope.onSubmitClick = function(){
            onSubmitClick($scope);
        };
        $scope.onCancelClick = function(){
            var service = util.getUrlParams().service;
            var redirectUrl = "https://id1.cloud.huawei.com/AMW/logout";
            service !== undefined ? service = "https://auth.huaweicloud.com/authui/logout?service=" + service : service = "https://auth.huaweicloud.com/authui/logout";
            window.location.href = redirectUrl + "?service=" + service;
        };
    };
    function onSubmitClick($scope){
        if (window.productType === "HWS" && $scope.model.disable) {
            iamUtils.MESSAGE.ERROR(i18n("privacyAgreementNotAcceptedError"), "", "popupMsg");
        } else {
            var temp = document.createElement("form");
            temp.action = iamUtils.getUrlParams()['isFromID'] == '1' ? "/authui/signPrivateAggreement" : '/authui/validateUser';
            if(window.location.search !== ""){
                temp.action = temp.action + "?" + window.location.search.substring(1,window.location.search.length);
            }
            temp.method = "post";
            temp.style.display = "none";
            var step = document.createElement("textarea");
            step.name = "step";
            step.value = "afterPrivatePolicy";
            temp.appendChild(step);
            // 统一ID兼容
            if(iamUtils.getUrlParams()['isFromID']){
                var opt = document.createElement("textarea");
                opt.name = "isFromID";
                opt.value = iamUtils.getUrlParams()['isFromID'];
                temp.appendChild(opt);
            }
            document.body.appendChild(temp);
            temp.submit();
        }
    }
    return privacyUpdateCtrl;
});



// WEBPACK FOOTER //
// ./public/base/js/privacyUpdate/controllers/privacyUpdateController.js